export const MAIN_PERIOD_ALIAS = 'main';
